<div class="value-container" [ngClass]="{ revert: revert, noFrame: noFrame }">
  <span>{{ value }}</span>
  <div class="border" *ngIf="!noFrame"></div>
</div>
